export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const LOGOUT = "LOGOUT";
export const DIALOG_STATE = "DIALOG_STATE";
export const UPDATE_USER_IMAGE_URL = "UPDATE_USER_IMAGE_URL";
export const UPDATE_MODELS = "UPDATE_MODELS";
export const UPDATE_MODELS_AND_FAV_MODELS = "UPDATE_MODELS_AND_FAV_MODELS";
export const ADD_FAV_MODEL = "ADD_FAV_MODEL";
export const REMOVE_FAV_MODEL = "REMOVE_FAV_MODEL";
// export const LIKED_MODEL = 'LIKED_MODEL';
